import React, { Component } from 'react'
import HeadingPattern2Component from '../BlockImageText2/HeadingPattern2Component';
import ContentXnComponent from '../ContentXnComponent';
import {isOpenImageModal, isOpenImageSettingModal} from '../../../../../Lib/redux/actions';
import { connect } from 'react-redux';
import { CKEditor } from "ckeditor4-react";
import ContentEditable from 'react-contenteditable';

export class BlockType4 extends Component {
  constructor(props) {
    super(props);
    this.renderContentBlock = this.renderContentBlock.bind(this)
    this.state = {
      isHeadingPattern0Edit: false,
      isSubHeadingPattern0Edit: false,
      isHeadingPattern1Edit: false,
      isSubHeadingPattern1Edit: false,
      isHeadingPattern2Edit: false,
      isSubHeadingPattern2Edit: false,
      isHeadingPattern3Edit: false,
      isSubHeadingPattern3Edit: false,
      isHeadingPattern4Edit: false,
      isSubHeadingPattern4Edit: false
    }
  }

  renderCKEditor(content, sort, alignType) {
    return (
      <CKEditor
        initData={content}
        type="inline"
        className="content-editable"
        onChange={(event) => this.props.handleChangeAlignText(sort, event, alignType)}
        config={{
          width: '100%',
          height: '300',
          language: 'ja',
          allowedContent: true,
          autoParagraph: false,
          extraPlugins: "justify,font,colorbutton,colordialog",
          font_names: '游ゴシック/Yu Gothic Medium;游明朝/Yu Mincho;ヒラギノ角ゴ Pro W3;メイリオ/メイリオ, Microsoft Sans Serif, Osaka, Arial, sans-serif;ＭＳ ゴシック/ＭＳ ゴシック;ＭＳ 明朝/ＭＳ 明朝;ＭＳ Ｐゴシック/ＭＳ Ｐゴシック;ＭＳ Ｐ明朝/ＭＳ Ｐ明朝;Verdana/Verdana;Arial/Arial;Courier New/Courier New;Times New Roman/Times New Roman',
          toolbar: [
            { name: 'paragraph', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight'] },
            { name: 'styles', items: ['Font'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'styles', items: ['FontSize'] }
          ],
          fontSize_sizes: '10px(PC) ~ 8.8px(SP)/1rem;12px(PC) ~ 10.56px(SP)/1.2rem;14px(PC) ~ 12.32px(SP)/1.4rem;16px(PC) ~ 14.08px(SP)/1.6rem;18px(PC) ~ 15.84px(SP)/1.8rem;20px(PC) ~ 17.6px(SP)/2rem;22px(PC) ~ 19.36px(SP)/2.2rem;24px(PC) ~ 21.12px(SP)/2.4rem;26px(PC) ~ 22.88px(SP)/2.6rem;28px(PC) ~ 24.64px(SP)/2.8rem;36px(PC) ~ 31.68px(SP)/3.6rem;48px(PC) ~ 42.24px(SP)/4.8rem;72px(PC) ~ 63.36px(SP)/7.2rem',
          title: false,
          versionCheck: false
        }}
      />
    );
  }

  renderSubHeadlinePattern(isEdit, content, sort) {
    let editable = this.props.kindOfDesign === 12 ? "h" : ""
    editable += isEdit ? " contenteditable" : "";
    editable += this.state[`isSubHeadingPattern${this.props.positionChild}Edit`] ? " active" : ""
    if (isEdit) {
      return(
        <p className={`h ${editable}`}>
          {this.renderCKEditor(content[`subheadline_pattern${this.props.positionChild}`], sort, `subheadline_pattern${this.props.positionChild}`)}
        </p>
      )
    }

    return (<p className={editable} dangerouslySetInnerHTML={{__html: content[`subheadline_pattern${this.props.positionChild}`]}}></p>)
  }

  renderContentBlock(){
    return (
      <React.Fragment>
        <div className="inner_item_img">
          { this.props.isEdit &&
            (
              <React.Fragment>
                <span className="admin_edit_link 378534" title="リンク設定" onClick={this.props.showBlockImgSettingModal}>
                  <i className="material-icons">link</i>
                </span>
                <span className="admin_edit_img 378534" title="画像を変更" onClick={this.props.showOperatorImageModal}>
                  <i className="material-icons">collections</i>
                </span>
              </React.Fragment>
            )
          }
          {this.props.showBlockImage()}
        </div>
        <div style={{ pointerEvents: "auto" }} className="inner_item_txt">
          { this.props.content.isShowTitleImageBlock !== "false" &&
          <div className={`heading block_header_4 ${this.props.headingPatternClass}`} data-target="1">
            <HeadingPattern2Component content={this.props.content} index={this.props.index} kindOfDesign={this.props.kindOfDesign}
                         positionChild={this.props.positionChild}
                         isEdit={this.props.isEdit}
                         sort={this.props.sort}
                         handleChangeAlignText={this.props.handleChangeAlignText} />
          </div>
          }
          <div className="pwrap fix_toolbar">
          { this.props.content.isShowTitleImageBlock !== "false" &&
            this.renderSubHeadlinePattern(this.props.isEdit, this.props.content, this.props.sort)
          }
            <div className="iwrap fix_toolbar"><img src={this.props.imageUrl()} /></div>
            <ContentXnComponent text={this.props.content[`text${this.props.positionChild}`]} positionChild={this.props.positionChild} contentClass={this.props.content[`contentClass${this.props.positionChild}`]} index={this.props.index} i={this.props.positionChild}
                           isEdit={this.props.isEdit}
                           sort={this.props.sort}
                           handleChangeText={this.props.handleChangeText}
                           handleChangeAlign={this.props.handleChangeAlign} />
          </div>
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { isVisitOuterLink, positionChild } = this.props;
    const hrefValue = this.props.hrefValue();
    return (
      <React.Fragment>
        { hrefValue != false && isVisitOuterLink &&
          <a href={hrefValue} target={this.props.targetValue(positionChild)}>
            {this.renderContentBlock()}
          </a>
        }
        {
          hrefValue != false && !isVisitOuterLink &&
          <a onClick={(e) => {e.preventDefault()}}>
            {this.renderContentBlock()}
          </a>
        }
        { hrefValue == false &&
          <React.Fragment>
            {this.renderContentBlock()}
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = (storeState, ownProps) => {
  let newState = Object.assign({}, ownProps);
  newState.isOpenImageModal = storeState.isOpenImageModal
  newState.isOpenImageSettingModal = storeState.isOpenImageSettingModal
  return newState;
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleShowImageModal: (data) => {dispatch(isOpenImageModal(data))},
    handleShowSetting: (data) => {dispatch(isOpenImageSettingModal(data))}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlockType4)
